<div
  *ngIf="workspace"
  class="db-workspace-popup"
  [ngClass]="{'none-events': showActivityLogTour || userSubscription?.boosterBetaClient}">
  <input type="checkbox" id="db-workspace-popup__trigger" class="db-workspace-popup__trigger"
         (change)="changeValue($event)" [checked]="isChecked || (showActivityLogTour && !isMobile)">
  @if (isCollapsed) {
    <label class="collapsed" for="db-workspace-popup__trigger db-has-workspace-dropdown"
           (click)="togglePopup($event)"
           [ngClass]="{'db-collapsed': isCollapsed,
           'db-with-invite': withInviteBlock,
           'db-has-own-workspace': currentWorkspace.roleId === workspaceRoles.SUITE_DEV
           && ((!expiredSubscr && user?.platformClient)
           || (userSubscription?.trialClient && !user?.hostingTrialExpired)),
           'db-opened': isChecked && !user?.hostingTrialExpired}">
      <div class="db-workspace-popup__picture db-collapsed">
        <div>
        <span *ngIf="!workspace.workspaceLogo"
              [ngStyle]="{backgroundColor: workspace.workspaceColor}">{{ user?.firstName.charAt(0).toUpperCase() }}</span>
          <div *ngIf="!!workspace.workspaceLogo"
               [ngStyle]="{backgroundImage: 'url(&quot;' + workspace.workspaceLogo + '&quot;)'}"></div>
        </div>
      </div>
    </label>
  } @else {
    <label for="db-workspace-popup__trigger db-has-workspace-dropdown"
           (click)="togglePopup($event)"
           [ngClass]="{'db-opened': isChecked && !userSubscription?.boosterBetaClient
       && (!user?.hostingTrialExpired
       || userSubscription?.type === userSubscriptionType.ONE_PRODUCT
       || userSubscription?.type === userSubscriptionType.PREMIUM),
       'db-has-own-workspace': currentWorkspace.roleId === workspaceRoles.OWNER
       && ((!expiredSubscr && user?.platformClient)
       || (userSubscription?.trialClient && !user?.hostingTrialExpired)
       || userSubscription?.boosterProClient)}">
      <div class="db-workspace-popup__picture"
           *ngIf="([userSubscriptionType.FREE, userSubscriptionType.PLATFORM].includes(user?.planType))">
        <div>
        <span *ngIf="!workspace.workspaceLogo"
              [ngStyle]="{backgroundColor: workspace.workspaceColor}">{{ user?.firstName.charAt(0).toUpperCase() }}</span>
          <div *ngIf="!!workspace.workspaceLogo"
               [ngStyle]="{backgroundImage: 'url(&quot;' + workspace.workspaceLogo + '&quot;)'}"></div>
        </div>
      </div>
      <div class="db-workspace-popup__info">
        <b [innerHTML]="'text_workspace' | dbText: {workspaceName: user?.firstName}" class="1"></b>
      </div>
      <i class="db-icon db-icon-ds-arrow-sharp"
         [ngClass]="{'db-toggled': isChecked}"></i>
    </label>
  }

  <div class="db-workspace-popup__popup-wrapper"
       [ngClass]="{'db-workspace-popup__popup-wrapper-hide': !isChecked, 'isCollapsed': !!isCollapsed}"
       (click)="closePopupOnWrapperClick($event)">
    <div class="db-workspace-popup__popup-content" (click)="$event.stopPropagation()">
      <div class="db-workspace-popup__popup-header">
        <div class="db-workspace-popup__popup-header-intro">
          <div class="db-workspace-popup__picture">
            <div>
              <span [ngStyle]="{backgroundColor: workspace.workspaceColor}"
                    *ngIf="!workspace.workspaceLogo">{{ user?.firstName.charAt(0).toUpperCase() }}</span>
              <div *ngIf="!!workspace.workspaceLogo"
                   [ngStyle]="{backgroundImage: 'url(&quot;' + workspace.workspaceLogo + '&quot;)'}"></div>
            </div>
          </div>
          <div class="db-workspace-popup__info">
            <b [innerHTML]="'text_workspace' | dbText: {workspaceName: user?.firstName}"></b>
          </div>
        </div>
      </div>

      <!-- Add own workspace option -->
      <div
        *ngIf="(!isOwnWorkspaceActive
      && ((user?.planType === userSubscriptionType.FREE && user?.hasHostingTrial && !user?.hostingTrialExpired)
      || user?.planType === userSubscriptionType.PLATFORM)
      && userSubscription.subscriptionId !== config.defaultStarterPlanId)"
        (click)="showCheckoutDialog(null, true)"
        class="db-workspace-popup__link db-workspace-popup__link-add ds-btn-gray" [style.width]="'272px'">
        <span [innerHTML]="'text_addOwnWorkspace' | dbText"></span>
      </div>



      <!-- Upgrade button -->
      <div class="db-workspace-popup__settings"
           [class.unavailable]="userSubscription?.is_non_billable && user?.hostingTrialExpired"
           *ngIf="![workspaceRoles.COMPANY_DEV, workspaceRoles.SITE_DEV].includes(workspace?.roleId)">
        <ul>
          <li *ngIf="hasUpgrade && !userSubscription?.is_non_billable"
             [routerLink]="![userSubscriptionStatus.canceled, userSubscriptionStatus.failed, userSubscriptionStatus.expired].includes(userSubscription.status) ? ['/upgrade-plan'] : ['/workspace/subscription-plan']"
             [queryParams]="{currentUser: true}"
             (click)="hidePopup(); sendFreeUpgradeEvent()">
            <a class="db-workspace-popup__link db-workspace-popup__link-upgrade">
              <span>{{ userSubscription?.trialClient ? ('text_explorePlans' | dbText) : ('text_changePlan' | dbText)}}</span>
              <i class="db-icon db-icon-ds-diamond-new"></i>
            </a>
          </li>

          <!-- Subscription plan -->
          <li *ngIf="!user?.hostingTrialExpired && ![userSubscriptionStatus.expired].includes(userSubscription.status)">
            <a class="db-workspace-popup__link db-workspace-popup__link-settings"
               [routerLink]="['/workspace/subscription-plan']"
               (click)="hidePopup()">
              <span>{{ 'text_subscription&Billing' | dbText }}</span>
            </a>
          </li>
          <!-- Workspace settings -->
          <li *ngIf="workspace.roleId === workspaceRoles.OWNER && !user?.hostingTrialExpired && !userSubscription?.isExpired">
            <a class="db-workspace-popup__link db-workspace-popup__link-settings"
               (click)="hidePopup('/workspace/workspace-settings')">
              <span>{{ 'text_workspaceInfo' | dbText }}</span>
            </a>
          </li>

        </ul>
      </div>


      <!-- Account information section similar to profile popup -->
      <div class="db-workspace-popup__user-information">
        <p>{{ 'text_accountSettings' | dbText }}</p>
        <div class="db-workspace-popup__user">
          <div class="db-workspace-popup__user-profile">
            <div class="db-workspace-popup__user-profile-picture">
              <img dbGravatar [email]="user?.email" [size]=100 alt="">
            </div>
            <div class="db-workspace-popup__user-details">
              <p>{{ user?.firstName }} {{ user?.lastName }}</p>
              <span>{{ user?.email }}</span>
            </div>
          </div>
          <a class="ds-btn ds-btn-gray" [style.width]="80+ 'px'"
             [routerLink]="['/account/account-settings']"
             (click)="hidePopup()">
            <span>{{ 'text_manage' | dbText}}</span>
          </a>
        </div>

        </div>

      <a class="db-workspace-popup__link db-workspace-popup__link-signout"
         (click)="logout()">
        <span>{{ 'text_sideBarLogOut' | dbText }}</span>
      </a>
      </div>

    </div>

  </div>

<div class="db-cover-content" *ngIf="showActivityLogTour && !isMobile"
     (click)="hasCloseButton && gotItActivityLog()"></div>

